import { admin, patient, clinical, contact, financial, help, report } from '../styles/colours';
export var RecordStylePropertiesByColor = {
    blank: function (theme) {
        var _a;
        return ({
            color: (_a = theme.backgroundTransparent) !== null && _a !== void 0 ? _a : 'transparent',
        });
    },
    admin: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsAdmin) !== null && _a !== void 0 ? _a : admin[300],
        });
    },
    animal: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsPatient) !== null && _a !== void 0 ? _a : patient[300],
        });
    },
    clinical: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsClinical) !== null && _a !== void 0 ? _a : clinical[500],
        });
    },
    contact: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsContact) !== null && _a !== void 0 ? _a : contact[400],
        });
    },
    financial: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsFinancial) !== null && _a !== void 0 ? _a : financial[700],
        });
    },
    help: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsHelp) !== null && _a !== void 0 ? _a : help[600],
        });
    },
    reporting: function (theme) {
        var _a;
        return ({
            color: (_a = theme.recordsReport) !== null && _a !== void 0 ? _a : report[300],
        });
    },
};
//# sourceMappingURL=RecordStylePropertiesByRecordColor.js.map